import { VerticalContainer } from '@american-autonomy/ag-ui';

import { TEST_ID } from './constants';
import type { FunctionComponent, Props } from './types';

import styles from './styles.module.scss';

const Panel: FunctionComponent<Props> = ({
    children,
    className = '',
    onClick,
    testId = TEST_ID
}) => (
    <VerticalContainer className={`${className} ${styles.panel}`} onClick={onClick} testId={testId}>
        {children}
    </VerticalContainer>
);

export default Panel;
